<qrcode [qrdata]="qrdata"
        [width]="width"
        [errorCorrectionLevel]="errorCorrectionLevel"
        [cssClass]="cssClass"
        [colorDark]="colorDark"
        [colorLight]="colorLight"
        [elementType]="elementType"
        [imageSrc]="imageSrc"
        [imageHeight]="imageHeight"
        [imageWidth]="imageWidth"
        [margin]="margin"
></qrcode>
